import React from 'react';
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';

import { getRecommendationDetails } from 'apis/RecommendationsAPI';
import RecommendationDetailsRoot from 'components/AiCompetitiveIntelligence/RecommendationDetailsRoot';
import ErrorMessage from 'components/lib/ErrorMessage';
import Loader from 'components/lib/Loader';

import { SPEED_TO_LEAD_CONFIG_ID, SPEED_TO_LEAD_QUERY_KEY } from './constants';
import SpeedToLeadOverall from './SpeedToLeadOverall';

const SpeedToLeadDetailsRoot = () => {
  const { recommendationId } = useParams();
  const { data, isLoading, isError } = useQuery({
    queryKey: [SPEED_TO_LEAD_QUERY_KEY.DETAILS, recommendationId],
    queryFn: () => getRecommendationDetails(Number(recommendationId)),
    enabled: Boolean(recommendationId),
    refetchOnWindowFocus: false,
  });

  if (isLoading) {
    return <Loader active />;
  }

  if (isError || !data) {
    return <ErrorMessage text="Failed to load Speed to Lead insight. Please try again." active />;
  }

  if (data.config.id === SPEED_TO_LEAD_CONFIG_ID.OVERALL) {
    return <SpeedToLeadOverall recommendation={data} />;
  }

  if (!(Object.values(SPEED_TO_LEAD_CONFIG_ID) as number[]).includes(data.config.id)) {
    return <ErrorMessage text="This insight is not part of Speed to Lead." active />;
  }

  return <RecommendationDetailsRoot />;
};

export default SpeedToLeadDetailsRoot;
